import { render, staticRenderFns } from "./bettingDetails.vue?vue&type=template&id=1842c2f6&scoped=true"
import script from "./bettingDetails.vue?vue&type=script&lang=js"
export * from "./bettingDetails.vue?vue&type=script&lang=js"
import style0 from "./bettingDetails.vue?vue&type=style&index=0&id=1842c2f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1842c2f6",
  null
  
)

export default component.exports